import { ScrollbarPlugin } from "smooth-scrollbar";

class HorizontalScrollPlugin extends ScrollbarPlugin {
	static pluginName = "horizontalScroll";

	static defaultOptions = {
		scrollXAxis: true
	}

	transformDelta(delta, fromEvent) {
		if (!/wheel/.test(fromEvent.type)) {
			return delta;
		}

		const { x, y } = delta;

		if (this.options.scrollXAxis) {
			return {
				y: 0,
				x: Math.abs(x) > Math.abs(y) ? x : y
			};
		}

		return {
			y: delta.y,
			x: delta.x
		}
	}
}

export default HorizontalScrollPlugin;